import React from 'react';
import { ArrowUp } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0a0a] text-white py-12 border-t border-gray-800">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo and copyright */}
          <div className="flex items-center gap-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_modern-gomobyle/artifacts/983mgmi8_Untitled%20design%20%281%29.png" 
              alt="Mobyle Logo" 
              className="h-12 w-auto brightness-0 invert"
            />
            <span className="text-gray-500 text-sm">
              © {companyInfo.currentYear} {companyInfo.name}. All rights reserved.
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm text-gray-500">
            <a href="#" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors duration-300">Terms of Service</a>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-white hover:text-black transition-colors duration-300"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
